<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>校外賃居租金補貼申請</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li><a href="/"><i class="fa fa-home"></i></a></li>
          <li><span>賃居管理</span></li>
          <li><span>校外賃居租金補貼申請</span></li>
        </ol>
      </div>
    </header>
    <div class="main">
      <section class="panel">
        <!-- 管理者：Tab 導航 + 查詢面板 -->
        <section class="panel panel-default" v-if="isAdminUser">
          <ul class="nav nav-tabs" role="tablist">
            <li class="active">
              <router-link :to="'/rent-subsidy/list'">申請清單</router-link>
            </li>
            <li>
              <router-link :to="'/rent-subsidy/timeSetting'">開放時間設定</router-link>
            </li>
            <li>
              <router-link :to="'/rent-subsidy/treaty'">設定隱私權宣告、申請資訊說明</router-link>
            </li>
          </ul>
          <header class="panel-heading" style="padding: 10px;">
            <div class="panel-actions" style="top: 7px;">
              <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
            </div>
            <h4 class="panel-title">查詢條件</h4>
          </header>
          <div id="searchArea" class="panel-collapse collapse in">
            <div class="panel-body">
              <!-- 第一排：學年度、學期、學制 -->
              <div class="row form-group">
                <div class="col-md-4 form-group">
                  <label for="schYear" class="col-sm-4 col-xs-2">學年度</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="schYear" v-model="qryParam.schYear" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="item in schYearList" :key="item" :value="item">{{item}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="smtr" class="col-sm-4 col-xs-2">學期</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="smtr" v-model="qryParam.smtr" class="form-control">
                      <option value="">請選擇</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="ssym" class="col-sm-4 col-xs-2">學制</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="ssym" v-model="qryParam.ssym" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- 第二排：科系、年級、班級 -->
              <div class="row form-group">
                <div class="col-md-4 form-group">
                  <label for="dept" class="col-sm-4 col-xs-2">科系</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="dept" v-model="qryParam.dept" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="grade" class="col-sm-4 col-xs-2">年級</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="grade" v-model="qryParam.grade" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="i in 9" :key="i" :value="String(i)">{{i}}年級</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="cls" class="col-sm-4 col-xs-2">班級</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="cls" v-model="qryParam.cls" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="c in ['A','B','C','D']" :key="c" :value="c">{{c}}班</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- 第三排：學號、姓名、審核狀態 -->
              <div class="row form-group">
                <div class="col-md-4 form-group">
                  <label for="account" class="col-sm-4 col-xs-2">學號</label>
                  <div class="col-sm-8 col-xs-10">
                    <input id="account" type="text" v-model="qryParam.account" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="name" class="col-sm-4 col-xs-2">姓名</label>
                  <div class="col-sm-8 col-xs-10">
                    <input id="name" type="text" v-model="qryParam.name" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="state" class="col-sm-4 col-xs-2">審核狀態</label>
                  <div class="col-sm-8 col-xs-10">
                    <select id="state" v-model="qryParam.state" class="form-control">
                      <option value="">請選擇</option>
                      <option v-for="(item,key) in reviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- 第四排：申請日期 -->
              <div class="row form-group">
                <div class="col-md-4 form-group">
                  <label for="crDateStart" class="col-sm-4 col-xs-2">申請日期起</label>
                  <div class="col-sm-8 col-xs-10">
                    <input id="crDateStart" type="date" v-model="qryParam.crDateStart" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4 form-group">
                  <label for="crDateEnd" class="col-sm-4 col-xs-2">申請日期迄</label>
                  <div class="col-sm-8 col-xs-10">
                    <input id="crDateEnd" type="date" v-model="qryParam.crDateEnd" class="form-control" />
                  </div>
                </div>
              </div>
              <!-- 查詢/清除按鈕 -->
              <div class="row form-group">
                <div class="col-md-4 form-group">
                  <button @click="updateGrid(1)" class="btn s_btn_b">查詢</button>
                  <button @click="clearSearchParam" class="btn s_btn_g">清除</button>
                </div>
              </div>
              <!-- 學期狀態統計 -->
              <template v-if="isAdminUser">
                <hr/>
                <h4 style="font-weight: bold">{{lastestSmtrState.schYear}} 學年第 {{lastestSmtrState.smtr}} 學期申請狀態</h4>
                <div class="col-md-12">
                  <div class="col-md-2"><h5>全部件數 : {{lastestSmtrState.total}}</h5></div>
                  <div class="col-md-2"><h5>待審件數 : {{lastestSmtrState.pending}}</h5></div>
                  <div class="col-md-2"><h5>審核通過件數 : {{lastestSmtrState.approval}}</h5></div>
                  <div class="col-md-2"><h5>審核不通過件數 : {{lastestSmtrState.reject}}</h5></div>
                  <div class="col-md-2"><h5>退回補件件數 : {{lastestSmtrState.incomplete}}</h5></div>
                </div>
              </template>
            </div>
          </div>
        </section>

        <!-- 資料表格 -->
        <section class="panel panel-default">
          <div class="tab-content">
            <div class="tab-pane fade in show" role="tabpanel">
              <div class="row form-group" v-if="canCreate || canExport">
                <div class="col-md-4 text-left form-inline" v-if="canCreate">
                  <button @click="handleCreateNew" class="btn s_btn_o">新增</button>
                </div>
                <div class="col-md-8 text-right" v-if="canExport">
                  <button @click="exportExcel" class="btn s_btn_b">匯出申請清單</button>
                  <button @click="exportWord" class="btn s_btn_b" style="margin-left:5px;">匯出核銷粘存單</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-no-more table-bordered table-striped mb-none">
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">序號</th>
                        <th class="text-center" width="7%">學年度</th>
                        <th class="text-center" width="5%">學期</th>
                        <th class="text-center" width="8%">學號</th>
                        <th class="text-center" width="8%">姓名</th>
                        <th class="text-center" width="15%">租賃起迄日</th>
                        <th class="text-center" width="20%">租賃地址</th>
                        <th class="text-center" width="10%">申請日期</th>
                        <th class="text-center" width="10%">審核狀態</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in applyList" :key="index">
                        <td data-title="序號" class="text-center">{{ (page - 1) * 10 + index + 1 }}</td>
                        <td data-title="學年度" class="text-center">{{ item.schYear }}</td>
                        <td data-title="學期" class="text-center">{{ item.smtr }}</td>
                        <td data-title="學號" class="text-center">{{ item.account }}</td>
                        <td data-title="姓名" class="text-center">
                          <a class="btn-link" style="cursor:pointer;" @click="$router.push({ path: '/rent-subsidy/edit', query: { id: item.id, mode: isAdminUser ? 'review' : 'student-apply' } })">{{ item.name }}</a>
                        </td>
                        <td data-title="租賃起迄日" class="text-center">
                          {{ item.rentStartDate ? item.rentStartDate.substring(0,10) : '' }} ~
                          {{ item.rentEndDate ? item.rentEndDate.substring(0,10) : '' }}
                        </td>
                        <td data-title="租賃地址" class="text-center">{{ item.rentAddress }}</td>
                        <td data-title="申請日期" class="text-center">{{ item.crDate ? item.crDate.substring(0,10) : '' }}</td>
                        <td data-title="審核狀態" class="text-center">{{ item.stateStr }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12">
                  <div class="text-center">
                    <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      qryParam: {
        schYear: "", smtr: "", ssym: "", dept: "", grade: "", cls: "",
        account: "", name: "", state: "", crDateStart: "", crDateEnd: ""
      },
      lastestSmtrState: { schYear: "", smtr: "", total: 0, pending: 0, approval: 0, reject: 0, incomplete: 0 },
      applyList: [],
      page: 1,
      totalPage: 1,
      ssymList: [],
      deptList: [],
      reviewStateList: [],
      schYearList: []
    };
  },
  computed: {
    isAdminUser() {
      return this.isAdmin('tenancy');
    },
    canCreate() {
      return this.isAdminUser || this.sessionData.accountType === 'STU';
    },
    canExport() {
      return this.isAdminUser;
    }
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    pageInit() {
      if (this.isAdminUser) {
        this.$axios.get("/api/rentsubsidyapply/listInit").then(res => {
          this.ssymList = res.data.data.selectList.ssym;
          this.deptList = res.data.data.selectList.dept;
          this.reviewStateList = res.data.data.selectList.reviewState;
          // 學年度從 114 開始，到目前民國年
          const currentYear = new Date().getFullYear() - 1911;
          const apiYears = res.data.data.selectList.smtr.map(s => s.schYear);
          const allYears = new Set([...apiYears]);
          for (let y = 114; y <= currentYear; y++) {
            allYears.add(String(y));
          }
          this.schYearList = [...allYears].sort((a, b) => Number(b) - Number(a));
        });
        this.$axios.get("/api/rentsubsidyapply/getLastestSmtrState").then(res => {
          this.lastestSmtrState = res.data.data;
        });

        // 恢復查詢設定
        const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
        if (storeQryParam != null) this.qryParam = storeQryParam;
        const storePage = this.getStore(`${this.$route.name}.page`);
        if (storePage != null) this.page = storePage;
      } else if (JSON.stringify(this.sessionData) !== '{}') {
        // 學生：自動帶入學號
        this.qryParam.account = this.sessionData.account;
      }
      this.updateGrid(this.page);
    },
    updateGrid(page = 1) {
      this.page = page;
      const query = new URLSearchParams({
        ...this.qryParam,
        page: this.page,
        pageSize: 10
      }).toString();
      this.$axios.get(`/api/rentsubsidyapply?${query}`).then(resp => {
        if (resp.data.status === "success") {
          this.applyList = resp.data.data.rows;
          this.totalPage = Math.ceil(resp.data.data.rowNum / resp.data.data.pageSize);
          this.page = resp.data.data.page;
        } else {
          bootbox.alert(resp.data.msg);
        }
      });
    },
    clearSearchParam() {
      this.qryParam = {
        schYear: "", smtr: "", ssym: "", dept: "", grade: "", cls: "",
        account: "", name: "", state: "", crDateStart: "", crDateEnd: ""
      };
      this.removeStore(`${this.$route.name}.qryParam`);
      this.removeStore(`${this.$route.name}.page`);
    },
    handleCreateNew() {
      if (this.isAdminUser) {
        // 管理員：admin-add 模式
        this.$router.push({ path: '/rent-subsidy/edit', query: { mode: 'admin-add' } });
      } else {
        // 學生：student-apply 模式（或不傳，讓 edit.vue 用默認值）
        this.$router.push({ path: '/rent-subsidy/edit' });
      }
    },
    exportExcel() {
      this.$axios.post("/api/rentsubsidyapply/export-excel", this.qryParam, { responseType: 'blob' }).then(resp => {
        const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '校外賃居租金補貼申請清單.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
    },
    exportWord() {
      this.$axios.post("/api/rentsubsidyapply/export-word", this.qryParam, { responseType: 'blob' }).then(resp => {
        // Check if response is actually an error (JSON/text returned as blob)
        const contentType = resp.headers['content-type'] || '';
        if (contentType.includes('application/problem') || contentType.includes('text/plain')) {
          const reader = new FileReader();
          reader.onload = () => { bootbox.alert(reader.result || '匯出失敗'); };
          reader.readAsText(resp.data);
          return;
        }
        const ext = contentType.includes('zip') ? 'zip' : 'docx';
        const blob = new Blob([resp.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `校外租金補貼核銷粘存單.${ext}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        if (err.response && err.response.data) {
          const reader = new FileReader();
          reader.onload = () => { bootbox.alert(reader.result || '匯出失敗，請確認有審核通過的資料'); };
          reader.readAsText(err.response.data);
        } else {
          bootbox.alert('匯出失敗');
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    if (["/rent-subsidy/edit"].includes(to.name)) {
      this.setStore(`${this.$route.name}.qryParam`, this.qryParam);
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    next();
  }
};
</script>

<style scoped>
</style>
